import { Route } from '@angular/router';
import { AprIndexPage } from 'app/modules/annulus-pressure-record/pages/index/index.page';
import { AprDtPage } from 'app/modules/annulus-pressure-record/pages/dt/dt.page';
import { AprEditPage } from 'app/modules/annulus-pressure-record/pages/apr-edit/apr-edit.component';
import { AprCreatePage } from 'app/modules/annulus-pressure-record/pages/apr-create/apr-create.component';
import { AprPiViewPage } from 'app/modules/annulus-pressure-record/pages/apr-pi-view/apr-pi-view.component';
import { AprDashboardPage } from './pages/apr-dashboard/apr-dashboard.component';

export const aprDashboardRoutes: Route[] = [
    {
        path: 'apr-dashboard',
        children: [
            {
                path: '',
                component: AprDashboardPage,
            }
        ],
    },
];

export const aprDataManagementRoutes: Route[] = [
    {
        path: 'annulus-pressure-record',
        children: [
            {
                path: '',
                component: AprIndexPage,
            },
            {
                path: ':id',
                component: AprCreatePage
            },
            {
                path: ':id/edit',
                component: AprEditPage
            },
            {
                path: ':id/view',
                component: AprPiViewPage
            },
        ]
    },
    {
        path: 'annulus-pressure-record',
        component: AprDtPage,

    },
];

export const aprConfigurationRoutes: Route[] = [
    {
        path: 'annulus-pressure-record',
        children: []
    },
];
